import accounting from 'accounting';

export default function (amount) {
  const formattedAmount = accounting.formatMoney(amount.amount, amount.symbol);
  return formattedAmount.replace(/\.00$/, '');
}
